import React from "react";
import styles from "./index.module.scss";
export default class TenderFilter extends React.Component {
    render() {
        return React.createElement("div", { className: styles.header }, "None");
    }
}
